/** Stroma Studio (#566) presentation, on design tokens so light and dark both follow the theme. */

export const panelSx = {
  bgcolor: 'var(--surface)',
  border: '1px solid var(--line)',
  borderRadius: '12px',
  minWidth: 0,
  overflow: 'hidden',
} as const;

export const panelHeadSx = {
  display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 1.25, flexWrap: 'wrap',
  px: 2, py: 1.5, borderBottom: '1px solid var(--line-soft)',
  '& h3': { m: 0, fontSize: 13, letterSpacing: '.07em', textTransform: 'uppercase', color: 'var(--ink-3)', fontWeight: 700 },
} as const;

export const metaSx = { fontSize: 12, color: 'var(--ink-3)' } as const;

export const tableSx = {
  width: '100%', borderCollapse: 'collapse', fontSize: 13.5,
  '& th': {
    textAlign: 'left', fontSize: 11, letterSpacing: '.07em', textTransform: 'uppercase', color: 'var(--ink-3)',
    px: 2, py: 1, borderBottom: '1px solid var(--line-soft)', fontWeight: 700, whiteSpace: 'nowrap',
  },
  '& td': { px: 2, py: 1.375, borderBottom: '1px solid var(--line-soft)', verticalAlign: 'middle', color: 'var(--ink)' },
  '& tr:last-of-type td': { borderBottom: 0 },
  '& tr.click': { cursor: 'pointer' },
  '& tr.click:hover td, & tr.click:focus-visible td': { bgcolor: 'var(--sunk)' },
  '& tr.click:focus-visible': { outline: '2px solid var(--accent)', outlineOffset: -2 },
  '& .meta': { fontSize: 12, color: 'var(--ink-3)' },
  '& .mono': { fontFamily: 'var(--mono)', fontSize: 12.5 },
  '& .num': { fontFamily: 'var(--mono)', fontVariantNumeric: 'tabular-nums' },
} as const;
